import React, { FC, useRef } from 'react';
import { FontColor, Headline2, Headline4, TextDefault } from '../../../Text';
import { Flexbox, FlexboxCenter, FlexboxVertical } from '../../../Layout';
import styled from 'styled-components';
import { Icon } from '../../../Icon';
import { PanelWithGradient } from '../../../PanelWithGradient';
import { Product } from '../../../../..';
import { parseProductColorSet } from '../../icons/ProductIconWrapper';
import { AnimatedContainer, AnimatedWhenVisible } from '../../../AnimatedContainer';

const MetaInfoWrapper = styled(FlexboxVertical)`
  margin: .25rem 0 2.5rem;
  
  ${Headline2}, ${Headline4} {
    text-align: start;
    margin-bottom: 1.5rem;
  }
  
  ${PanelWithGradient} {
    padding: 3rem 2rem;
    margin-bottom: 4.5rem;

    ul {
      list-style: none;

      li {
        margin-bottom: .75rem;
        
        ${TextDefault} {
          margin-left: 1rem;
        }
      }
      
      *:last-child {
        li {
          margin-bottom: 0;
        }
      }
    }
  }
`;

const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const BestPracticesPanel = styled(Flexbox)`
  justify-content: flex-start;
  align-items: flex-start;
  
  ${FlexboxVertical} {
    flex: 1;
    padding-right: 2.5rem;
  }
`;

const BenefitsIconWrapper = styled(FlexboxCenter)`
  padding: 0 1.5rem 1rem 3rem;
`;
const BenefitsIcon = styled.img`
  width: auto;
  height: 7rem;
  object-fit: contain;
`;

interface Props {
  product?: Product;
  visible?: boolean;
}
export const ProductDetailBenefitsSection: FC<Props> = ({ product, visible = true, ...props }) => {
  const panelViewRef = useRef<HTMLDivElement | null>(null);
  const accentColor = parseProductColorSet(product?.metaProduct?.colorSet);

  return (
    <MetaInfoWrapper>
      <FontColor color={accentColor}><Headline2>{ product?.metaProduct?.productBenefit?.title }</Headline2></FontColor>

      <PanelWithGradient ref={panelViewRef} product={product}>
        <AnimatedWhenVisible visible={visible} viewRef={panelViewRef}>
          {(readyToAnimate) => (
            <ul>
              {
                product?.metaProduct?.productBenefit?.list?.map((item, index, array) => (
                  <AnimatedContainer active={readyToAnimate} delay={100 * index}>
                    <ListItem>
                      <Icon icon={'check-bold'} size={16} />
                      <TextDefault>{ item }</TextDefault>
                    </ListItem>
                  </AnimatedContainer>
                ))
              }
            </ul>
          )}
        </AnimatedWhenVisible>
      </PanelWithGradient>

      <BestPracticesPanel>
        <BenefitsIconWrapper>
          <BenefitsIcon alt={''} src={'./assets/images/lightbulb.svg'} />
        </BenefitsIconWrapper>
        <FlexboxVertical>
          <Headline4 dangerouslySetInnerHTML={{ __html: product?.metaProduct?.productBenefit?.hint?.title }} />
          {
            (product?.metaProduct?.productBenefit?.hint?.text || []).map((text) => (
              <TextDefault dangerouslySetInnerHTML={{ __html: text }} />
            ))
          }
        </FlexboxVertical>
      </BestPracticesPanel>

    </MetaInfoWrapper>
  );
}
